import "./styles.css";
import React, { Component } from "react";
import CheckoutHeader from "./components/CheckoutHeader";
import FormInfoContact from "./components/FormInfoContact";
import { connect } from "react-redux";
import CheckoutInvoice from "./components/CheckoutInvoice";
import CheckoutSteps from "./components/CheckoutSteps";
import { Grid, Divider, Loader } from "semantic-ui-react";
import ProductsAccordion from "./components/CheckoutInvoice/components/ProductsAccordion";
import InvoiceDetails from "./components/CheckoutInvoice/components/InvoiceDetails";
// import DiscountCodeForm from "./components/CheckoutInvoice/components/DiscountCodeForm";
import InfoFormDataDisplay from "./components/InfoFormDataDisplay";
import { getCosts } from "../../redux/actions/payment";
import { getCurrency } from "../../redux/actions/currencySelect";
import { loadUser } from "../../redux/actions/auth";
import { getAddresses } from "../../redux/actions/addresses";
import { getAlldepartaments } from "../../redux/actions/departaments";
import { getCheckoutState } from "../../redux/actions/checkout";
import { getCustomizationCostValue } from "../../commons/functions/generalFunctions";
import PurchaseSuccess from "./components/PurchaseSuccess";
import { OrderNote } from "./components/OrderNote";
import CardInfo from "./components/FormInfoCard";
import AccountModal from "./components/AccountModal";
import {
  // getTotalUSD,
  getUsdSubTotal,
  getSubTotal,
  getTotal,
  getCustomizationCost,
  getUsdTotal,
} from "./functions/commonFunctions";

const { Column, Row } = Grid;
const moment = require("moment-timezone");
// const zone_name = moment.tz.guess();
moment.tz.setDefault("America/Tegucigalpa");

const today = moment().format("YYYY-MM-DD");

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      step: 0,
      currencySelect: this.props.currencySelect,
      customizationCost: this.props.customizationCost || 0,
      customizationCostUSD: 0,
      formInfo: {
        afternoon: { value: "true", error: "" },
        recipientCode: { value: "", error: "" },
        recipientPhone: { value: "", error: "" },
        recipientName: { value: "", error: "" },
        names: { value: "", error: "" },
        surnames: { value: "", error: "" },
        email: { value: "", error: "" },
        phone: { value: "", error: "" },
        code: { value: "", error: "" },
        addressLine1: { value: "", error: "" },
        addressLine2: { value: "", error: "" },
        department: { value: "", error: "" },
        municipality: { value: "", error: "" },
        //postal: { value: "", error: "" },
        notifications: false,
        date: {
          value:
            moment(today + " 15:00", "YYYY-MM-DD hh:mm").diff(
              moment(),
              "hours"
            ) <= 0
              ? moment().add(1, "days").format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
          error: "",
        },
      },
      cardInfo: {
        cardName: { value: "", error: "" },
        cardNumber: { value: "", error: "" },
        cardExpiryDate: { value: "", error: "" },
        cardCVV2: { value: "", error: "" },
      },
      orderInfo: { orderNumber: "" },
      applyShippingCost: true,
      applyCustomizationCost: null,
      discount: 0,
      note: "",
      purchaseSuccess: false,
      letter: "",
      nCaracteresLetter: 200,
      validWordsLetter: true,
      radio: "true",
      profile: {},
      paymentMethod: {
        value: "card",
      },
      loadingPay: false,
      noAccountInfo: true,
      shippingCost: 0,
    };
  }
  componentDidMount() {
    this.props.getAlldepartaments();

    if (this.props.cart.length === 0) {
      this.props.history.push("/");
    }
    this.props.getCheckoutState();
    this.props.getCosts();
    this.props.getCurrency();

    if (
      this.props.authentication.isLoaded &&
      !this.props.authentication.isEmpty
    ) {
      this.props.loadUser(this.props.authentication);
      this.setState({ profile: this.props.authentication.profile });
      if (this.props.addresses.loading) {
        this.props.getAddresses();
      }
    }
    this.setState({ noAccountInfo: this.props.authentication.isEmpty });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.checkout.data !== this.props.checkout.data) {
      this.setState({
        ...this.props.checkout.data,
        orderInfo: { orderNumber: "" },
      });
    } else {
      if (
        prevProps.customizationCost !== this.props.customizationCost ||
        prevProps.currencySelect.currency !== this.props.currencySelect.currency
      ) {
        const { cart, customizationCost } = this.props;
        this.setState({
          customizationCost: getCustomizationCostValue(
            getCustomizationCost({ cart, customizationCost }),
            this.props.currencySelect.currency.currency,
            this.props.currencySelect.currency.currencyLayer
              ? this.props.currencySelect.currency.currencyLayer.data.value
              : null
          ),
          customizationCostUSD: getCustomizationCostValue(
            getCustomizationCost({ cart, customizationCost }),
            "USD",
            this.props.currencySelect.currency.currencyLayer
              ? this.props.currencySelect.currency.currencyLayer.data.value
              : null
          ),
        });
        if (
          this.props.authentication.isLoaded &&
          !this.props.authentication.isEmpty
        ) {
          await this.props.loadUser(this.props.authentication);
          this.setState({ profile: this.props.authentication.profile });
          this.setState({
            formInfo: {
              ...this.state.formInfo,
              names: { value: this.state.profile.name, error: "" },
              surnames: { value: this.state.profile.lastName, error: "" },
              email: { value: this.state.profile.email, error: "" },
            },
          });
          if (this.props.addresses.loading) {
            this.props.getAddresses();
          }
        }
      }
    }
  }

  goToStepZero = () => {
    this.setState({ step: 0 });
  };
  goToStepOne = () => {
    this.setState({ step: 1 });
  };
  setFormInfo = (formInfo) => {
    this.setState({ formInfo });
  };
  goToStepTwo = (formInfo) => {
    this.setState({ formInfo, step: 2 });
  };
  changeNote = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  setApplyShippingCost = (applyShippingCost) => {
    this.setState({ applyShippingCost });
  };
  setPurchaseSuccess = () => {
    this.setState({ purchaseSuccess: true });
  };
  setOrderNumber = (orderNumber) => {
    this.setState({ orderInfo: { orderNumber } });
  };

  setCurrency = (currencySelect) => {
    this.setState({ currencySelect });
  };

  setLoading = (loading) => {
    this.setState({ loading });
  };

  setError = (error) => {
    this.setState({ error });
  };

  setCardDetails = (cardDetails) => {
    this.setState({
      cardInfo: cardDetails,
    });
  };

  validateWordsLetter = (letter) => {
    if (letter.length <= this.state.nCaracteresLetter) {
      this.setState({ validWordsLetter: true });
    } else {
      this.setState({ validWordsLetter: false });
    }
  };

  handleLocalLetter = () => {
    const dedicatoria = localStorage.getItem("dedicatoria");
    if (dedicatoria) {
      this.validateWordsLetter(dedicatoria);
      this.setState({ letter: dedicatoria });
    }
  };
  handleTextLetterChange = (e) => {
    this.validateWordsLetter(e.target.value);
    this.setState({ letter: e.target.value });
  };

  handleRadio = (value) => this.setState({ radio: value });

  handlePaymentMethod = (e, { value }) => {
    this.setState({
      paymentMethod: {
        value,
      },
    });
  };

  handleAccountModal = () => this.setState({ noAccountInfo: false });

  handleShippingCost = (value) => this.setState({ shippingCost: value });

  render() {
    const {
      loading,
      step,
      formInfo,
      applyShippingCost,
      discount,
      note,
      nCaracteresLetter,
      validWordsLetter,
      letter,
      radio,
      profile,
      customizationCost,
      // customizationCostUSD,
      purchaseSuccess,
      shippingCost,
      noAccountInfo,
    } = this.state;
    const {
      authentication,
      addresses,
      cart,
      currencySelect,
      history,
      departaments,
    } = this.props;

    const subtotal = getSubTotal({ currencySelect, cart });
    const usdSubTotal = getUsdSubTotal({ currencySelect, cart });

    // Comenté esta función debido a que me parece que la nueva función es más fácil de entender.
    // const totalUSD = getTotalUSD({
    //   currencySelect,
    //   applyShippingCost,
    //   discount,
    //   customizationCostUSD,
    //   cart,
    //   shippingCost,
    // });

    const totalUSD = getUsdTotal({
      shippingCost,
      currencySelect,
      applyShippingCost,
      discount,
      customizationCost,
      cart,
    });

    const total = getTotal({
      shippingCost,
      currencySelect,
      applyShippingCost,
      discount,
      customizationCost,
      cart,
    });

    return (
      <div>
        <AccountModal
          isOpen={
            authentication.isLoaded && authentication.isEmpty && noAccountInfo
          }
          event={this.handleAccountModal}
        />
        <CheckoutHeader />
        {purchaseSuccess ? (
          <PurchaseSuccess />
        ) : (
          <div>
            <div className="text-center">
              <CheckoutSteps step={step} />
            </div>
            {authentication.isLoaded && !loading ? (
              <div className="main-checkout-container">
                <Grid stackable className="hide-on-mobile">
                  <Row columns={2}>
                    <Column
                      largeScreen={8}
                      computer={8}
                      mobile={16}
                      tablet={16}
                      className="invoice-column"
                    >
                      <div className="checkout-invoice-container">
                        {step === 1 && (
                          <OrderNote
                            changeNote={this.changeNote}
                            radio={radio}
                            nCaracteresLetter={nCaracteresLetter}
                            validWordsLetter={validWordsLetter}
                            letter={letter}
                            note={note}
                            handleTextLetterChange={this.handleTextLetterChange}
                            handleRadio={this.handleRadio}
                          />
                        )}
                        <CheckoutInvoice
                          step={step}
                          total={total}
                          subtotal={subtotal}
                          totalUSD={totalUSD}
                          usdSubTotal={usdSubTotal}
                          applyShippingCost={applyShippingCost}
                          formInfo={formInfo}
                          customizationCost={this.state.customizationCost}
                          shippingCost={shippingCost}
                          setCurrency={this.setCurrency}
                        />
                      </div>
                    </Column>
                    <Column
                      largeScreen={8}
                      computer={8}
                      tablet={16}
                      mobile={16}
                    >
                      <div className="checkout-container-form">
                        {step < 2 && (
                          <FormInfoContact
                            step={step}
                            setFormInfo={this.setFormInfo}
                            validWordsLetter={validWordsLetter}
                            formInfo={formInfo}
                            goToStepZero={this.goToStepZero}
                            goToStepOne={this.goToStepOne}
                            goToStepTwo={this.goToStepTwo}
                            setApplyShippingCost={this.setApplyShippingCost}
                            profile={profile}
                            addresses={addresses}
                            authentication={authentication}
                            departaments={departaments}
                            handleShippingCost={this.handleShippingCost}
                          />
                        )}
                        {step === 2 && (
                          <div>
                            <InfoFormDataDisplay
                              goToStepZero={this.goToStepZero}
                              goToStepOne={this.goToStepOne}
                              step={step}
                              formInfo={formInfo}
                              letter={letter}
                              radio={radio}
                            />
                            <CardInfo
                              shippingDetails={this.state}
                              currencySelect={currencySelect}
                              setCardDetails={this.setCardDetails}
                              setOrderNumber={this.setOrderNumber}
                              subtotal={subtotal}
                              total={total}
                              usdSubTotal={usdSubTotal}
                              totalUSD={totalUSD}
                              setPurchaseSuccess={this.setPurchaseSuccess}
                              setLoading={this.setLoading}
                              cart={cart}
                              shippingCost={shippingCost}
                              setError={this.setError}
                              history={history}
                            />
                          </div>
                        )}
                      </div>
                    </Column>
                  </Row>
                </Grid>
                <div className="hide-on-largescreen">
                  <div className="checkout-mobile-container">
                    <ProductsAccordion />
                    <Divider />
                    {step === 1 && (
                      <OrderNote
                        changeNote={this.changeNote}
                        radio={radio}
                        nCaracteresLetter={nCaracteresLetter}
                        validWordsLetter={validWordsLetter}
                        letter={letter}
                        note={note}
                        handleTextLetterChange={this.handleTextLetterChange}
                        handleRadio={this.handleRadio}
                      />
                    )}
                    {step < 2 && (
                      <FormInfoContact
                        step={step}
                        goToStepZero={this.goToStepZero}
                        formInfo={formInfo}
                        validWordsLetter={validWordsLetter}
                        goToStepOne={this.goToStepOne}
                        goToStepTwo={this.goToStepTwo}
                        setFormInfo={this.setFormInfo}
                        setApplyShippingCost={this.setApplyShippingCost}
                        profile={profile}
                        addresses={addresses}
                        authentication={authentication}
                        departaments={departaments}
                        handleShippingCost={this.handleShippingCost}
                      />
                    )}

                    {step === 2 && (
                      <div>
                        <InfoFormDataDisplay
                          goToStepZero={this.goToStepZero}
                          goToStepOne={this.goToStepOne}
                          step={step}
                          formInfo={formInfo}
                          letter={letter}
                          radio={radio}
                        />

                        <CardInfo
                          shippingDetails={this.state}
                          currencySelect={currencySelect}
                          setCardDetails={this.setCardDetails}
                          setOrderNumber={this.setOrderNumber}
                          subtotal={subtotal}
                          usdSubTotal={usdSubTotal}
                          total={total}
                          totalUSD={totalUSD}
                          setPurchaseSuccess={this.setPurchaseSuccess}
                          setLoading={this.setLoading}
                          cart={cart}
                          shippingCost={shippingCost}
                          setError={this.setError}
                          history={history}
                        />
                      </div>
                    )}
                    {/* <Divider />
                  <DiscountCodeForm /> */}
                    <Divider />
                    <InvoiceDetails
                      formInfo={formInfo}
                      step={step}
                      total={total}
                      subtotal={subtotal}
                      applyShippingCost={applyShippingCost}
                      shippingCost={shippingCost}
                      customizationCost={this.state.customizationCost}
                      setCurrency={this.setCurrency}
                      totalUSD={totalUSD}
                      usdSubTotal={usdSubTotal}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="loader-container">
                <Loader
                  style={{ alignSelf: "center" }}
                  size="large"
                  inline="centered"
                  active
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = ({
  payment,
  currencySelect,
  cart,
  firebase,
  addresses,
  checkout,
  departaments,
}) => ({
  shippingCost: payment.shippingCost,
  customizationCost: payment.customizationCost,
  currencySelect,
  cart: cart.cart,
  authentication: firebase.auth,
  addresses,
  checkout,
  departaments,
});
export default connect(mapStateToProps, {
  getCosts,
  getCurrency,
  loadUser,
  getAddresses,
  getCheckoutState,
  getAlldepartaments,
})(Checkout);
